import React from 'react';

const Introduction: React.FC = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-16 text-center">
      <div className="mb-8">
        <h1 className="text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-primary-600 to-primary-700 bg-clip-text text-transparent mb-4 animate-fade-in">
          Lista de Presentes
        </h1>
        <p className="text-2xl md:text-3xl font-light text-text-secondary mt-2">
          um carinho para a casa nova do Ivola 🏡
        </p>
      </div>

      <div className="bg-gradient-card backdrop-blur-sm rounded-2xl shadow-soft-lg p-8 md:p-12 mb-8 border border-white/50 transform transition-all hover:shadow-soft-lg hover:scale-[1.01]">
        <div className="space-y-6 text-left">
          <p className="text-xl md:text-2xl text-text-primary leading-relaxed font-medium text-center">
            Olá, queridos familiares e amigos! 💗
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-600 mx-auto rounded-full"></div>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
            Esta lista nasceu de uma iniciativa dos amigos de <strong className="text-text-primary font-semibold">Ivo Barboza</strong>, que resolveram se reunir para fazer uma surpresa e celebrar, com muito carinho, essa nova fase da vida dele.
          </p>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
            E ele ainda não sabe de nada! 🤫
          </p>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
            A participação é totalmente espontânea,{' '}
            <strong className="text-text-primary font-semibold">sem qualquer obrigatoriedade</strong>.
            Quem quiser fazer parte dessa surpresa pode escolher um item da lista e contribuir, à sua maneira, para deixar a casa nova do Ivo ainda mais especial. 🏡✨
          </p>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
            Para mantermos a surpresa, os presentes serão reunidos pelos amigos e entregues ao Ivola posteriormente. Por isso, pedimos apenas que não sejam enviados diretamente para ele. As orientações sobre a entrega estarão disponíveis junto à lista.
          </p>
          <p className="text-lg md:text-xl text-text-primary leading-relaxed font-medium text-center">
            Obrigada por fazer parte desse carinho! 💛
          </p>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
